import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ItemsLoading from '../../../../components/Loaders/ItemsLoading'
import SkeletonListRow from '../../../../features/components/List/Skeleton'
import PageSection from '../../../../features/components/PageSection'
import List from '../../../../features/components/List'

import { selectedPartnershipSelector } from '../../../../modules/selectors/partnerships'
import { clearAudiences, getAudiences } from '../../../../modules/actions/audiences'
import { DV_360_PLATFORM } from '../../../../constants/selectLists/platformList'
import {
  audiencesErrorSelector,
  audiencesLoadingSelector,
  audiencesSelector,
  audiencesWasLoadedSelector
} from '../../../../modules/selectors/audiences'

import { commonColumns } from '../commonColumns'

import useCommonStyles from '../../../../styles/common/listPage'

const Dv360AudienceTable = () => {
  const dispatch = useDispatch()
  const commonClasses = useCommonStyles()

  const audiences = useSelector(audiencesSelector)

  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const dv360AdAccountId = selectedPartnership?.dv360_ad_account?.external_id

  const listSkeletonProps = useMemo(() => ({ cols: commonColumns }), [])

  useEffect(() => {
    dispatch(
      getAudiences(
        {
          account: dv360AdAccountId,
          filter_by_account_id: true
        },
        DV_360_PLATFORM
      )
    )
  }, [dispatch, dv360AdAccountId])

  useEffect(
    () => () => {
      dispatch(clearAudiences())
    },
    [dispatch]
  )

  return (
    <ItemsLoading
      className={commonClasses.itemList}
      itemsLength={audiences.length}
      SkeletonComponent={SkeletonListRow}
      skeletonProps={listSkeletonProps}
      errorSelector={audiencesErrorSelector}
      isLoadingSelector={audiencesLoadingSelector}
      wasLoadedSelector={audiencesWasLoadedSelector}
      ContentWrapper={PageSection}
    >
      <List cols={commonColumns} listData={audiences} Skeleton={<SkeletonListRow {...listSkeletonProps} />} />
    </ItemsLoading>
  )
}

export default Dv360AudienceTable
